@if (isExpert) {
  <nav class="mb-col-8 breadcrumbs">
    <mb-breadcrumbs>
      <a mb-breadcrumb-item href="/">Home</a>
      <a
        mb-breadcrumb-item
        (click)="hotelLink()"
        href="javascript:;"
        i18n="@@breadcrumbs_alojamientos"
        >Alojamientos</a
      >
      @if (!hotelName) {
        <a mb-breadcrumb-item>
          {{ busy ? '...' : searchedEntity?.name ? searchedEntity.name : entity }}</a
        >
      }
      @if (hotelName && entity.name) {
        <a
          mb-breadcrumb-item
          (click)="cityLink($event)"
          href="javascript:;"
        >
          {{ entity.name ? entity.name : entity }}
        </a>
      }
      @if (hotelName) {
        <a mb-breadcrumb-item> {{ hotelName }} </a>
      }
    </mb-breadcrumbs>
  </nav>
}
